import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import spaced from '@ui/styled/Spaced';

const SpacedGridItem = spaced(CenteredGridItem);

export default SpacedGridItem;
